module.exports = __webpack_public_path__ + "media/images/peb/20px/peb_c-d623d628375f25caba57bd608228723a.png";